
import { Button } from '@material-ui/core';
const CancelButton = ({ onClick }) => (<Button variant="outlined" color="primary" onClick={onClick}>
    Cancel
</Button>)

export default CancelButton